// extracted by mini-css-extract-plugin
module.exports = {"invoiceNav":"InvoiceNavigation_invoiceNav__2xHlv","invoiceNavButton":"InvoiceNavigation_invoiceNavButton__1thmp"};